export const PATA_PAY_FEATURES_CONFIG = [
  {
    title: 'Flexible payments',
    description:
      'Meet your clients’ needs, whether they prefer to pay upfront when booking online or on the spot with a card.',
    icon: 'Membership',
  },
  {
    title: 'Reduce no-shows',
    description:
      'Secure your bookings by charging deposits in advance, or collecting payment cards for late cancellation and no-show fees.',
    icon: 'NoShow',
  },
  {
    title: 'Fast payout',
    description: 'Get paid in an instant and track transactions in real time on the Pata Platform.',
    icon: 'Thunder',
  },
  {
    title: 'No hidden fees',
    description:
      'Enjoy low processing fees* at just 1.75% + £0.45 per card reader transaction and 2.99% + £0.45 for online payments.',
    icon: 'Bill',
  },
  {
    title: 'Integration with Pata',
    description:
      'Manage payments, appointments, and client details effortlessly – with Pata, everything you need stays in one place.',
    icon: 'Desktop',
  },
  {
    title: 'Protected payments',
    description:
      'Enable your clients to pay with confidence while you enjoy peace of mind thanks to encrypted payment technology and secure transactions.',
    icon: 'Security',
  },
];
